const enrollmentStepToPosthog = (stepNumber: number) => {
    switch (stepNumber) {
        case 0:
            return { event: 'enrollment:program_join_viewed', step_key: 'enrollment_landing' };
        case 1:
            return { event: 'enrollment:join_a_program_selected', step_key: 'program_selection' };
        case 2:
            return { event: 'enrollment:account_creation_submitted', step_key: 'account_creation' };
        case 3:
            return { event: 'enrollment:account_details_submitted', step_key: 'account_details' };
        case 4:
            return {
                event: 'enrollment:security_settings_submitted',
                step_key: 'account_security',
            };
        case 5:
            return { event: 'enrollment:2fa_phone_submitted', step_key: '2fa_phone' };
        case 6:
            return { event: 'enrollment:2fa_code_verified', step_key: '2fa_code' };
        case 7:
        case 8:
            return { event: 'enrollment:enrollment_completed', step_key: 'enrollment_completed' };
        default:
            return null;
    }
};

// named keys to prevent collisions with the step number keys
const enrollmentStepNameToPosthog = (stepName: string) => {
    switch (stepName) {
        case 'viewed_enrollment_landing':
        case 'join_a_program_view':
            return { event: 'enrollment:program_join_viewed', step_key: 'join_a_program_view' };
        case 'join_a_program_selected':
            return {
                event: 'enrollment:join_a_program_selected',
                step_key: 'join_a_program_selected',
            };
        case 'enrollment_code_submitted':
            return {
                event: 'enrollment:enrollment_code_submitted',
                step_key: 'enrollment_code_submitted',
            };
        case 'create_an_account':
            return {
                event: 'enrollment:account_creation_submitted',
                step_key: 'account_creation',
            };
        case 'account_details':
            return {
                event: 'enrollment:account_details_submitted',
                step_key: 'account_details',
            };
        case 'account_security':
            return {
                event: 'enrollment:security_settings_submitted',
                step_key: 'account_security',
            };
        case '2FA_phone':
            return { event: 'enrollment:2fa_phone_submitted', step_key: '2fa_phone' };
        case '2FA_code':
            return { event: 'enrollment:2fa_code_verified', step_key: '2fa_code' };
        default:
            return null;
    }
};

export default enrollmentStepToPosthog;
export { enrollmentStepNameToPosthog };
